<template>
<div class="chapter">
<div class="inner_page">
<h1>I Love Ramen</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<span href="#/ch01" title="Link target outside of Sample">Introduction </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">Soups &amp; Salads</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e153" title="Link target outside of Sample">Slow Chicken Soup </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e186" title="Link target outside of Sample">Curried Chicken Soup </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e218" title="Link target outside of Sample">Ham &amp; Black-Eyed Peas </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e246" title="Link target outside of Sample">Spicy Shrimp &amp; Noodle Soup </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e285" title="Link target outside of Sample">South of the Border Ramen Soup </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e326" title="Link target outside of Sample">Miso &amp; Veggie Ramen Soup </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e362" title="Link target outside of Sample">Chunky Noodle Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e396" title="Link target outside of Sample">Tossed Mandarin Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e440" title="Link target outside of Sample">Crunchy Fruit Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e460" title="Link target outside of Sample">Antipasto Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e480" title="Link target outside of Sample">Nutty Broccoli Slaw </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e515" title="Link target outside of Sample">Taco Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e537" title="Link target outside of Sample">Quick Chicken Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e567" title="Link target outside of Sample">Oriental Chicken Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e599" title="Link target outside of Sample">Tofu &amp; Cabbage Toss </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e645" title="Link target outside of Sample">Tangerine Chicken Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e690" title="Link target outside of Sample">Chicken Fajita Ramen Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e731" title="Link target outside of Sample">Three Sprout Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e778" title="Link target outside of Sample">Polish Ramen Salad </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Beef &amp; Pork Mains</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e808" title="Link target outside of Sample">Ramen Rolled Steak </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e841" title="Link target outside of Sample">Yatsobi </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e884" title="Link target outside of Sample">Slow Cooker Beef &amp; Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e904" title="Link target outside of Sample">Beef Ramenoff </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e934" title="Link target outside of Sample">Stuffed Bell Peppers </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e975" title="Link target outside of Sample">Creamy Beef &amp; Broccoli Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1003" title="Link target outside of Sample">Beef Provençale</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1035" title="Link target outside of Sample">Cheddar Beef Casserole </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1067" title="Link target outside of Sample">Beefy Mushroom Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1095" title="Link target outside of Sample">Beef &amp; Broccoli Stir-Fry </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1126" title="Link target outside of Sample">Beef Sukiyaki </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1162" title="Link target outside of Sample">Beef &amp; Chestnut Casserole </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1192" title="Link target outside of Sample">Beefy Chili Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1223" title="Link target outside of Sample">Cheeseburger Ramen</span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1243" title="Link target outside of Sample">Oriental Hot Dogs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1267" title="Link target outside of Sample">Cheesy Bacon Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1290" title="Link target outside of Sample">Pork Chops &amp; Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1314" title="Link target outside of Sample">Hungarian Goulash à la Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1338" title="Link target outside of Sample">Saucy Chops &amp; Peppers </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1379" title="Link target outside of Sample">Tropical Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1406" title="Link target outside of Sample">Broccoli, Mushroom &amp; Ham Casserole
                                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1442" title="Link target outside of Sample">Spicy Sausage Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1468" title="Link target outside of Sample">Gingered Pork &amp; Snow Peas </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1503" title="Link target outside of Sample">Breakfast Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e1539" title="Link target outside of Sample">Bacon-Fried Ramen </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Chicken &amp; Turkey Mains</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1571" title="Link target outside of Sample">Chicken Broccoli Bake </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1616" title="Link target outside of Sample">Cheesy Chicken Divan </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1650" title="Link target outside of Sample">Herbed Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1680" title="Link target outside of Sample">Hot &amp; Sour Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1717" title="Link target outside of Sample">Cheesy Chicken Casserole </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1745" title="Link target outside of Sample">Chicken ’n’ Asparagus </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1767" title="Link target outside of Sample">Honey Grilled Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1818" title="Link target outside of Sample">Chicken Alfredo </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1848" title="Link target outside of Sample">Thai Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1870" title="Link target outside of Sample">Fiesta Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1903" title="Link target outside of Sample">Chicken Lo Mein </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1929" title="Link target outside of Sample">Chilled Caesar Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1951" title="Link target outside of Sample">Turkey Pasta Pie </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e1998" title="Link target outside of Sample">Pesto Turkey &amp; Pasta </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Seafood Mains</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2024" title="Link target outside of Sample">Garlic Shrimp ’n’ Veggies </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2055" title="Link target outside of Sample">Salmon Simmer </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2081" title="Link target outside of Sample">Cajun Shrimp &amp; Chicken Gumbo </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2109" title="Link target outside of Sample">Crab Lo Mein </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2148" title="Link target outside of Sample">Coconut Curry Shrimp </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e2183" title="Link target outside of Sample">Tuna Noodle Casserole </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Veggie Mains &amp; Sides</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2213" title="Link target outside of Sample">Spinach Parmesan Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2248" title="Link target outside of Sample">Cheesy Vegetable Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2268" title="Link target outside of Sample">Pan-Fried Noodles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2290" title="Link target outside of Sample">Asian Noodle Toss </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2321" title="Link target outside of Sample">Grilled Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2345" title="Link target outside of Sample">Frittatas </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2373" title="Link target outside of Sample">Stuffed Tomatoes </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2414" title="Link target outside of Sample">Pizza Pasta </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2440" title="Link target outside of Sample">Cheesy Ranch Ramen </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2456" title="Link target outside of Sample">Primavera Pasta </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2491" title="Link target outside of Sample">Buttery Chive Noodles </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Sweet on Ramen</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2513" title="Link target outside of Sample">Trail Mix </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2547" title="Link target outside of Sample">Maple &amp; Brown Sugar Ramenmeal </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2569" title="Link target outside of Sample">Caramel Crisps </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2593" title="Link target outside of Sample">Thin Mint on a Stick </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?41205253